const config = {
  "secretKey": "$Hj7aF#k9l*D@v!3G",
  "numberOfRows": 100,
  "authMethod": "JWT",
  "endPoint": "https://millada-test.millennium.sk/MillAI_BE",
  "subDir" : "/",
  "imgAllowed": true,
  "msgReviewsAllowed" : true,
  "jwtAllowed": true  ,
  "adAllowed" : false,
  "adConfig": {
    "clientId": "",
    "authority":"",
    "redirectUri": ""
  }
}
export default config;